import { IReplacementObject } from 'src/grammar-checker/models/api';
import { IOverlayRangeData } from '../handlers/grammar-check';

export interface GcErrorState {
  anchorEl: HTMLElement | null;
  errorNodeHoverState: boolean;
  cardHoverState: boolean;
}

export interface GcErrorDetailState {
  contentToReplaceIndex: number;
  overlayParagraphHash: number;
  overlayParagraphIndex: number;
  overlayRangeData: IOverlayRangeData;
  replacementObject: IReplacementObject;
  idOfOverlaysToRemove: string;
  sentence: string;
}

export interface GrammarState {
  isGrammarCheckRunning: boolean;
  isFixAllGrammarDisabled: boolean;
  paintGrammarResponse: boolean;
  grammarResponse: {
    [originalTextHash: number]: IReplacementObject[];
  };
  paragraphIndexToPaint: number[] | 'all' | 'none';
  retriggerPaintGrammarResponse: boolean;
}

export const TOGGLE_GRAMMAR_CHECK = 'rshr/system/toggle_grammar_check';
export const TOGGLE_PAINT_GRAMMAR_RESPONSE = 'rshr/user/toggle_paint_grammar_response';
export const TOGGLE_GRAMMAR_CHECK_FIX_ALL_BUTTON_STATE =
  'rshr/system/toggle_grammar_check_fix_all_button_state';
export const APPEND_GRAMMAR_RESPONSE = 'rshr/system/append_grammar_response';
export const REMOVE_GRAMMAR_RESPONSE = 'rshr/system/remove_grammar_response';
export const UPDATE_GRAMMAR_RESPONSE = 'rshr/system/update_grammar_response';
export const RESET_GRAMMAR_RESPONSE = 'rshr/system/reset_grammar_response';
export const PARA_INDEX_TO_PAINT = 'rshr/system/para_index_to_paint';
export const RETRIGGER_PAINT_GRAMMAR_RESPONSE = 'rshr/system/retrigger_paint_grammar_response';
export const MARK_GRAMMAR_RESPONSE_AS_PAINTED = 'rshr/system/mark_grammar_response_as_painted';

export interface ToggleGrammarCheck {
  type: typeof TOGGLE_GRAMMAR_CHECK;
  payload: {
    isGrammarCheckRunning: boolean;
  };
}

export interface TogglePaintGrammarResponse {
  type: typeof TOGGLE_PAINT_GRAMMAR_RESPONSE;
  payload: {
    paintGrammarResponse: boolean;
  };
}

export interface ToggleGrammarCheckFixAllButtonState {
  type: typeof TOGGLE_GRAMMAR_CHECK_FIX_ALL_BUTTON_STATE;
  payload: {
    isFixAllGrammarDisabled: boolean;
  };
}

export interface AppendGrammarResponse {
  type: typeof APPEND_GRAMMAR_RESPONSE;
  payload: { originalTextHash: number; replacementObjects: IReplacementObject[] };
}

export interface RemoveGrammarResponse {
  type: typeof REMOVE_GRAMMAR_RESPONSE;
  payload: { originalTextHash: number; indexForSpecificReplacementObject: number };
}

export interface UpdateGrammarResponse {
  type: typeof UPDATE_GRAMMAR_RESPONSE;
  payload: { originalTextHash: number; replacementObjects: IReplacementObject[] };
}

export interface ResetGrammarResponse {
  type: typeof RESET_GRAMMAR_RESPONSE;
}

export interface ParaIndexToPaint {
  type: typeof PARA_INDEX_TO_PAINT;
  payload: { index: number[] | 'all' | 'none' };
}

export interface RetriggerPaintGrammarResponse {
  type: typeof RETRIGGER_PAINT_GRAMMAR_RESPONSE;
}

export interface MarkGrammarResponseAsPainted {
  type: typeof MARK_GRAMMAR_RESPONSE_AS_PAINTED;
}

export type ControlActionTypes =
  | ToggleGrammarCheck
  | TogglePaintGrammarResponse
  | ToggleGrammarCheckFixAllButtonState
  | AppendGrammarResponse
  | ResetGrammarResponse
  | ParaIndexToPaint
  | RetriggerPaintGrammarResponse
  | MarkGrammarResponseAsPainted
  | RemoveGrammarResponse
  | UpdateGrammarResponse;
